export default __webpack_public_path__ + "static/media/up-blue-arrow.e37e5107.svg";